<template>

    <!-- change image -->
    <div class="selectImage TQ_center">


        <croppa v-model="myCroppa"
                class="TQ_border TQ_borderRadius TQ_box_shadow"
                :width="width"
                :height="height"
                canvas-color="white"
                :initial-image="p_initialImage_s"
                placeholder="Upload New Image"/>

        <br>

        <img @click="myCroppa.zoomOut()" :src="ass_img_minus_w" class="TQ_width_24px TQ_bg_black TQ_padding_4px TQ_borderRadius TQ_clickable" />
        <div class="TQ_inline TQ_padding_2px"> </div>
        <img @click="myCroppa.zoomIn()" :src="ass_img_add_w" class="TQ_width_24px TQ_bg_black TQ_padding_4px TQ_borderRadius TQ_clickable" />
        <div class="TQ_inline TQ_padding_8px"> </div>
        <div class="TQ_inline TQ_padding_8px"> </div>
        <img @click="myCroppa.rotate()" :src="ass_img_rotate90degree_w" class="TQ_width_24px TQ_bg_black TQ_padding_4px TQ_borderRadius TQ_clickable" />


    </div>

</template>

<script>
    import Croppa from 'vue-croppa';
    import 'vue-croppa/dist/vue-croppa.css'
    import {enum_fileType} from "../../../functions/src/shareCode/Share_S_Enum";
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {FB_File} from "../../../functions/src/shareCode/Share_S_Classes";
    import {
        ass_img_add_w,
        ass_img_minus_w,
        ass_img_rotate90degree_w
    } from "../../assets/scripts/Ass_Files";
    import {notification_notify} from "../../scripts/S_Notification";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqTabs from "../basic/TqTabs";
    import {validator_typeOfVal_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {enum_langCodes, enum_typeof} from "../../../functions/src/shareCode/Share_S_Enum";

    export default {
        name: "TqSelectImage",
        components :{
            TqTabs,
            Croppa : Croppa.component
        },
        props:{
            p_initialImage_s:{
                value: String
            },
            width:{
                default: 500,
                type: Number
            },
            height:{
                default: 300,
                type: Number
            },
            p_getImageFile_vf:{
                type: Object,
                require: true,
                validator(obj){
                    return validator_typeOfVal_fb(obj, enum_typeof.function)
                }
            },
            p_fileName_s:{
                type: String,
                require: true,
            },
            p_index_n:{
                type: Number,
                require: true,
            },
            ps_langCode_e:{
                type: String,
                require:true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },

        },
        data(){
            return{
                selectedFile_c: null,
                selectedTab_vn : {val : 0},
                myCroppa: {},
                supportedHeightAndWidthRatio: ['800,480', '700,420', '600,360', '500,300'],


                // imports
                ass_img_minus_w     : ass_img_minus_w,
                ass_strings         : ass_strings,
                ass_img_add_w       : ass_img_add_w,
                ass_img_rotate90degree_w : ass_img_rotate90degree_w
            }
        },
        mounted(){

            if(this.p_getImageFile_vf != null){

                this.p_getImageFile_vf.val = ((cb_f) => {

                    if(this.selectedFile_c != null ){
                        cb_f(this.selectedFile_c)
                        return
                    }

                    this.myCroppa.generateBlob(
                        blob => {
                            if(blob){
                                cb_f(new FB_File({
                                    fi_fileName_s    : this.p_fileName_s,
                                        url         : URL.createObjectURL(blob),
                                        type        : blob.type,
                                        index       : this.p_index_n,
                                        fi_sizeBytes_n : blob.size,
                                }))
                            } else{
                                alert("You didnt upload any photo")
                            }
                        },
                        'image/jpeg',
                        0.8
                    ); // 80% compressed jpeg file
                })
            }



        }

    }
</script>

<style scoped>

    .selectImage{
        text-align: center;
    }


</style>
